module.exports = __webpack_public_path__ + "img/TSY_01.b8fbb5ad.jpg";